// One editorial section: an H2 + description head row (with optional right-aligned actions on the
// title row, per the design — e.g. "Run sync now"), then the content inside a calm card. `bare`
// skips the card for sections whose children render their own cards (the rule-set builders).
export default function Section({ id, title, description, actions, bare, children }) {
	return (
		<section id={id} className="ei-section">
			<div className="ei-sechead">
				<div className="ei-sechead-txt">
					<h2 className="ei-sec-title">{title}</h2>
					{description ? <p className="ei-sec-desc">{description}</p> : null}
				</div>
				{actions ? <div className="ei-sec-actions">{actions}</div> : null}
			</div>
			{bare ? children : <div className="js-card">{children}</div>}
		</section>
	);
}
